import { Loadable } from "common/Loadable";
import { clubActions, clubSelectors } from "data/resources/clubs";
import { goalActions, goalSelectors } from "data/resources/goals";
import { messages as challengeMessages, _Challenges } from "features/homepage/Challenges";
import { OrgContext } from "features/organizations/OrgContext";
import { useFormatMessage } from "lib/localization";
import { promiseMapAll } from "lib/utils";
import React from "react";
import { defineMessages } from "react-intl";
import { connect } from "react-redux";
import { OrganizationLayout } from "../OrganizationLayout";
import styles from "./OrganizationChallenges.scss";

export const messages = defineMessages({
  defaultName: {
    id: "OrganizationChallenges.defaultName",
    defaultMessage: "Untitled Challenge",
  },
});

export const _OrganizationChallenges = ({
  fm,
  goals,
  createGoal,
  clubIdParam,
  loadableResources: { goalsPromise },
}) => {
  const { club_member: currentMember } = goalsPromise?.action?.payload?.meta;
  const onNewChallengeClick = () =>
    createGoal(fm(messages.defaultName)).then((r) => {
      window.location = `/challenges/${r.action.payload.goal.id}/overview`;
    });

  return (
    <OrganizationLayout>
      <OrgContext.Provider
        value={{
          isCurrentClub: window.rwgps?.config?.club?.slug === clubIdParam,
          currentMember,
        }}
      >
        <div className={styles.orgChallenges}>
          <_Challenges goals={goals} onNewChallengeClick={onNewChallengeClick} fm={fm} />
        </div>
      </OrgContext.Provider>
    </OrganizationLayout>
  );
};

const LoadableClubChallenges = (props) => {
  const fm = useFormatMessage();
  const { match, loadGoals, loadClub } = props;
  const clubId = match.params.clubIdParam;

  const loadInitialResources = () => {
    return promiseMapAll({
      goalsPromise: loadGoals(
        {
          clubId,
          scope: "challenges",
        },
        { identifier: clubId }
      ),
      __: loadClub(match.params.clubIdParam),
    });
  };

  return (
    <Loadable
      {...props}
      fm={fm}
      component={_OrganizationChallenges}
      loadingText={fm(challengeMessages.loadingText)}
      resourceLoaded={loadInitialResources}
    />
  );
};

const mapStateToProps = (state, ownProps) => {
  const {
    params: { clubIdParam },
  } = ownProps.match;
  return {
    currentUser: state.currentUser,
    goals: goalSelectors.allForUser(state, clubIdParam),
    club: clubSelectors.bySlug(state, clubIdParam),
    clubIdParam,
  };
};

const mapDispatchToProps = {
  loadGoals: goalActions.list,
  loadClub: clubActions.read,
  createGoal: (name) => goalActions.create({ goal: { name } }),
};

export const OrganizationChallenges = connect(mapStateToProps, mapDispatchToProps)(LoadableClubChallenges);
